import countries from "../GeneralServices/Country";
import auth from "../GeneralServices/Auth";
import profile from "../GeneralServices/Profile";
import reservations from '../GeneralServices/Reservations';
import customers from '../GeneralServices/Customer';
import drivers from '../GeneralServices/Drivers';
import services from '../GeneralServices/Services';
import flight from "../GeneralServices/Flight";
import upload from "../GeneralServices/Upload";
import waypoints from "../GeneralServices/Waypoints";

export default {
    countries: countries,
    auth: auth,
    profile: profile,
    reservations: reservations,
    customers: customers,
    drivers: drivers,
    rates: services,
    flight: flight,
    upload: upload,
    waypoints: waypoints
}